import type { FC } from "react";

import type {
  TDialogHeaderProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib/utils";

export const DialogHeader: FC<TDialogHeaderProps> = (
  {
    className,
    ...props
  },
) => (
  <div
    data-component="DialogHeader"
    className={cn(
      "flex flex-col gap-1",
      className,
    )}
    {...props}
  />
);

DialogHeader.displayName = "DialogHeader";
